import React from 'react';
import { connect } from 'react-redux';
import packageJson from '../../package.json';
import { fetchAllVersions } from '../actions';
import { Trans } from 'react-i18next';

class Version extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            versions: ["Test"]
        };
    }

    componentDidMount() {
        this.props.fetchAllVersions();
    }

    render() {
        return (
            <div>
                <p><Trans i18nKey="Frontend_version" /> {packageJson.version}</p>
                <ul>
                    { this.props.versions.map(version => <li>{version}</li>)}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const vers = state.project.versions ? state.project.versions.split(";") : ["unknown"];
    return {
        versions: vers,
    };
};

const mapDispatchToProps = {
    fetchAllVersions
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Version);
